export const WarningOffsetForPasswordExpirationDays: number = 2;
